'use strict';

var ON_PREM_TO_ON_PREM = 'ON_PREM_TO_ON_PREM';
var ON_PREM_TO_S3 = 'ON_PREM_TO_S3';
var S3_TO_ON_PREM = 'S3_TO_ON_PREM';
var ON_PREM_TO_GCS = 'ON_PREM_TO_GCS';
var GCS_TO_ON_PREM = 'GCS_TO_ON_PREM';

module.exports = {
    ON_PREM_TO_ON_PREM: ON_PREM_TO_ON_PREM,
    ON_PREM_TO_S3: ON_PREM_TO_S3,
    ON_PREM_TO_GCS: ON_PREM_TO_GCS,
    S3_TO_ON_PREM: S3_TO_ON_PREM,
    GCS_TO_ON_PREM: GCS_TO_ON_PREM
};